import React, { ReactElement } from "react";

const PlusIcon = (): ReactElement => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.625 8.375C14.625 8.02982 14.3452 7.75 14 7.75C13.6548 7.75 13.375 8.02982 13.375 8.375V13.375H8.375C8.02982 13.375 7.75 13.6548 7.75 14C7.75 14.3452 8.02982 14.625 8.375 14.625H13.375V19.625C13.375 19.9702 13.6548 20.25 14 20.25C14.3452 20.25 14.625 19.9702 14.625 19.625V14.625H19.625C19.9702 14.625 20.25 14.3452 20.25 14C20.25 13.6548 19.9702 13.375 19.625 13.375H14.625V8.375Z"
      fill="#1C1C1C"
    />
  </svg>
);

export default PlusIcon;
